import { apiFetch } from '../admin/jscontrol/apiClient';

const storefrontOptions = { useStorefrontAuth: true };

export async function fetchOrderItems(params = {}) {
  const qs = new URLSearchParams({
    pageIndex: String(params.pageIndex ?? 1),
    pageSize: String(params.pageSize ?? 10),
    search: params.search ?? '',
    sortColumn: params.sortColumn ?? 'OrderItemId',
    sortBy: (params.sortBy ?? 'DESC').toUpperCase(),
  });
  if (params.orderId) qs.set('orderId', String(params.orderId));

  const authOptions = params.useStorefront ? storefrontOptions : undefined;
  const { data } = await apiFetch(`/OrderItem/GetAll?${qs}`, authOptions);
  return {
    items: Array.isArray(data?.data) ? data.data : [],
    totalRecords: data?.totalRecords ?? 0,
  };
}

export async function fetchOrderItemsForOrder(orderId, pageSize = 100) {
  return fetchOrderItems({ orderId, pageIndex: 1, pageSize, useStorefront: true });
}

export async function fetchOrderItemById(orderItemId) {
  const { data } = await apiFetch(`/OrderItem/GetById/${orderItemId}`);
  if (data?.success === false) throw new Error(data?.message || 'Order item not found.');
  return data?.data ?? data;
}

export async function createOrderItemApi(payload) {
  const { data } = await apiFetch('/OrderItem/Create', { method: 'POST', data: payload });
  if (data?.success === false) throw new Error(data?.message || 'Could not create order item.');
  return data?.data?.OrderItemId ?? data?.data?.orderItemId ?? null;
}

export async function updateOrderItemApi(payload) {
  const { data } = await apiFetch('/OrderItem/Update', { method: 'PUT', data: payload });
  if (data?.success === false) throw new Error(data?.message || 'Could not update order item.');
}

export async function deleteOrderItemApi(orderItemId) {
  const { data } = await apiFetch(`/OrderItem/Delete/${orderItemId}`, { method: 'DELETE' });
  if (data?.success === false) throw new Error(data?.message || 'Could not delete order item.');
}
